import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AchievementsSection = ({ achievements, onShare }) => {
  return (
    <div className="bg-card rounded-xl shadow-md p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg">
          <Icon name="Award" size={24} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Achievements & Badges
          </h2>
          <p className="text-sm text-muted-foreground caption">
            Your fitness milestones
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {achievements?.map((achievement, index) => (
          <div
            key={index}
            className={`relative p-4 rounded-lg border-2 transition-smooth hover-lift ${
              achievement?.unlocked
                ? 'bg-gradient-to-br from-accent/10 to-primary/10 border-accent' :'bg-muted/30 border-border opacity-60'
            }`}
          >
            <div className="flex flex-col items-center text-center">
              <div className={`flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full mb-3 ${
                achievement?.unlocked ? 'bg-accent/20' : 'bg-muted'
              }`}>
                <Icon
                  name={achievement?.icon}
                  size={32}
                  color={achievement?.unlocked ? 'var(--color-accent)' : 'var(--color-muted-foreground)'}
                  strokeWidth={2}
                />
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">
                {achievement?.name}
              </h3>
              <p className="text-xs text-muted-foreground caption">
                {achievement?.description}
              </p>
              {achievement?.unlocked && (
                <div className="mt-3">
                  <p className="text-xs text-muted-foreground caption">
                    Unlocked: {achievement?.unlockedDate}
                  </p>
                </div>
              )}
            </div>
            {achievement?.unlocked && (
              <div className="absolute top-2 right-2">
                <div className="flex items-center justify-center w-6 h-6 bg-success text-success-foreground rounded-full">
                  <Icon name="Check" size={14} strokeWidth={3} />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="text-sm text-muted-foreground caption">
              {achievements?.filter(a => a?.unlocked)?.length} of {achievements?.length} achievements unlocked
            </p>
            <div className="w-full sm:w-64 h-2 bg-muted rounded-full mt-2 overflow-hidden">
              <div
                className="h-full bg-accent rounded-full transition-smooth"
                style={{
                  width: `${(achievements?.filter(a => a?.unlocked)?.length / achievements?.length) * 100}%`
                }}
              />
            </div>
          </div>
          <Button
            variant="outline"
            size="default"
            iconName="Share2"
            iconPosition="left"
            onClick={onShare}
          >
            Share Achievements
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AchievementsSection;